module.exports = __webpack_public_path__ + "media/printed-materials/educators-08-hs-qrg-f26a3303.jpg";